import { useLocation } from "react-router-dom";

export const useIsArtworkDetailPage = () => {
  const { pathname } = useLocation();

  const regex = /^\/artist\/[^/]+\/artwork\/[^/]+$/;

  return regex.test(pathname);
};
